import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ControlService from './ControlService';

// Integración con el MTESS por empresa (control.usa_mtess). El MTESS deshabilitó
// sus APIs y la integración quedó apagada en todas las empresas: se ocultan los
// accesos, columnas y acciones de MTESS salvo que la empresa la tenga encendida.
// Mientras no se sabe, o si falla la consulta, se asume apagada.
const cache = {};

async function cargar(company) {
    if (!company) return false;
    if (!(company in cache)) {
        cache[company] = ControlService.getControl({ company_id: company })
            .then(result => {
                const control = result && result.data && result.data.data && result.data.data[0];
                return !!control && control.usa_mtess === true;
            })
            .catch(() => false);
    }
    return cache[company];
}

export default function useMtessHabilitado() {
    const user = useSelector(({ auth }) => auth.user);
    const company = useSelector(state => state.fuse.empresa?.empresaSeleccionada || user.data.company_id);
    const [habilitado, setHabilitado] = useState(false);

    useEffect(() => {
        let vigente = true;
        cargar(company).then(valor => { if (vigente) setHabilitado(valor) });
        return () => { vigente = false };
    }, [company]);

    return habilitado;
}
